import { setUser } from '@sentry/react';
import type { CurrentUserDetails } from '@unifyapps/network/generated/models/currentUserDetails';

export function setErrorReportingUser(user: CurrentUserDetails) {
  if (process.env.IS_SENTRY_ENABLED) {
    setUser({
      id: user.user?.id,
      username: user.user?.username,
      email: user.user?.email,
      customerId: user.customer?.id,
      customerName: user.customer?.name,
    });
  } else if (
    process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID &&
    process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
  ) {
    void import('@datadog/browser-rum').then(({ datadogRum }) =>
      datadogRum.setUser({ id: user.user?.id }),
    );
  } else if (process.env.NODE_ENV === 'development') {
    // local development
    // console.log('setUser', user);
  }
}
